import { BasicInfoProps, CaseInfo, RealDealData } from '../../data';
import { s } from './Summary.styles';
import ImgSlider from './ImgSlider';
import { NplCalculation } from '../../../../utils/nplAnalysis';
import { formatToEokMan, ReportFormatNumber } from '../../../../func/Function';
import { forwardRef, useEffect, useState } from 'react';
import InterestSerivce from '../../../../service/Interest';
import AddInterestItemModal from '../../../components/modal/AddInterestItem';
import { isLogin } from '../../../../utils/auth';
import { useModal } from '../../../../context/ModalContext';
import styled from 'styled-components';
import Tags from './Tags';
import { handleShareDetailPage } from '../../../../utils/url';

interface ImgItem {
  imgNo: string;
  src: string;
  description?: string;
}

interface Props {
  caseInfo: CaseInfo;
  summary: ReturnType<NplCalculation['getSummary']>;
  imgList?: ImgItem[];
  basicInfo: BasicInfoProps | undefined;
  realPriceData: RealDealData | undefined;
  landInfo: { pnu: string } | any;
  viewInfo?: any;
  isLikeItem: boolean;
  setIsLikeItem: (isLikeItem: boolean) => void;
  checkIsLikeItem?: (iidx: number) => void;
  regionAccess?: boolean;
}

const NPLInvestmentSummary = forwardRef<HTMLDivElement, Props>(
  (
    {
      caseInfo,
      summary,
      imgList,
      basicInfo,
      realPriceData,
      landInfo,
      viewInfo,
      isLikeItem,
      setIsLikeItem,
      checkIsLikeItem,
      regionAccess,
    },
    ref,
  ) => {
    const { modalDispatch } = useModal();
    const [showLikeModal, setShowLikeModal] = useState(false);
    const [mode, setMode] = useState<string>('add');
    const [selectedItem, setSelectedItem] = useState({
      iidx: 0,
      group: '',
      group_idx: 0,
      level: 0,
      memo: '',
    });
    const [activeItem, setActiveItem] = useState<number | null>(null);
    const [unit, setUnit] = useState('p');

    const formatDate = (date: string) => {
      if (date.includes('-')) {
        const [year, month, day] = date.split('-');
        return `${year}년 ${month}월 ${day}일`;
      } else if (date.includes('.')) {
        const [year, month, day] = date.split('.');
        return `${year}년 ${month}월 ${day}일`;
      }
    };

    const handleCopyAddress = () => {
      navigator.clipboard
        .writeText(caseInfo?.iaddr ? caseInfo.iaddr : '')
        .then(() => {
          alert('주소가 복사되었습니다!');
        })
        .catch((err) => {
          console.error('주소 복사에 실패했습니다:', err);
          alert('주소 복사에 실패했습니다.');
        });
    };

    const handleTopAction = (action: string) => {
      if (action === 'share') {
        const currentUrl = window.location.href;
        navigator.clipboard
          .writeText(currentUrl)
          .then(() => {
            alert('URL이 복사되었습니다!');
          })
          .catch(() => {
            alert('URL 복사에 실패했습니다.');
          });
      }
    };

    const disLike = async (iidx: number) => {
      try {
        const res = await InterestSerivce.dislike(iidx);
        alert('관심물건에서 삭제되었습니다.');
        setIsLikeItem(false);
      } catch (error) {
        console.error('dislike 함수에서 에러 발생:', error);
      }
    };

    const handleDisLikeItem = (iidx: number) => {
      if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
        disLike(iidx);
      }
    };

    const convertPriceForUnit = (
      unit: string,
      landArea: number | string,
      landPyeong: number,
      buildingArea: number | string,
      buildingPyeong: number,
    ) => {
      if (
        buildingPyeong === null &&
        typeof buildingArea === 'string' &&
        buildingArea.includes('지분')
      ) {
        buildingArea = Number(
          buildingArea
            .toString()
            .split('지분')[1]
            .replace(/[^0-9.]/g, ''),
        );
        buildingPyeong = buildingArea / 3.3058; // m² to 평 변환
      }
      if (
        landPyeong === null &&
        typeof landArea === 'string' &&
        landArea.includes('지분')
      ) {
        landArea = Number(
          landArea
            .toString()
            .split('지분')[1]
            .replace(/[^0-9.]/g, ''),
        );
        landPyeong = landArea / 3.3058; // m² to 평 변환
      }

      let area =
        typeof buildingArea === 'number' && buildingArea > 0
          ? buildingArea
          : Number(landArea);
      let pyeong = buildingPyeong > 0 ? buildingPyeong : landPyeong;

      if (unit === 'p') {
        return pyeong.toFixed(1);
      }

      return area.toFixed(1);
    };

    return (
      <s.Container id="요약정보">
        {/* 이미지 */}
        {/* {imgList && imgList.length > 0 && (
          <ImgSlider imgList={imgList} iidx={caseInfo.iidx} />
        )} */}
        <s.SimpleInfoBox>
          <s.Dot />
          <s.SimpleInfoText>{caseInfo.bid}</s.SimpleInfoText>
          <s.SimpleInfoDivider />
          <s.SimpleInfoText>{caseInfo.status}</s.SimpleInfoText>
        </s.SimpleInfoBox>
        <s.SummaryBox>
          <s.SummaryDetail>
            <s.TitleArea>
              <s.TitleAreaTop ref={ref}>
                <s.ItemTypeChip type={caseInfo.type}>
                  {caseInfo.type === 'a' ? '경매' : '공매'}
                </s.ItemTypeChip>
                <s.TitleAreaTopButtonBox>
                  <s.ButtonIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!isLogin()) {
                        modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                        return;
                      }

                      if (!isLikeItem) {
                        setShowLikeModal(true);
                      } else {
                        handleDisLikeItem(caseInfo.iidx);
                      }
                    }}
                  >
                    <img
                      src={`/assets/images/icon/${isLikeItem ? 'like-on' : 'like-off'}.svg`}
                      alt="like"
                    />
                  </s.ButtonIcon>
                  <s.ButtonIcon onClick={() => handleShareDetailPage(caseInfo)}>
                    <img src="/assets/images/icon/share.svg" alt="share" />
                  </s.ButtonIcon>
                </s.TitleAreaTopButtonBox>
              </s.TitleAreaTop>
              <s.Address>{caseInfo?.iaddr2 ? caseInfo.iaddr2 : ''}</s.Address>
              <s.AddressDetail>
                {caseInfo.roadnamelocation}
                <s.CopyAddress onClick={handleCopyAddress}>
                  <img
                    src="/assets/images/icon/copy-blue.svg"
                    alt=""
                    width={16}
                    height={16}
                  />
                  <span>주소복사</span>
                </s.CopyAddress>
              </s.AddressDetail>
            </s.TitleArea>
            <s.RowDivider />
            <s.DetailArea>
              <s.InfoArea>
                <s.InfoList>
                  {/* <s.Info>
                    <img
                      src="/assets/images/icon/building-outline.svg"
                      alt=""
                    />
                    <s.InfoText>
                      <span style={{ color: '#008AFF', fontWeight: 700 }}>
                        {basicInfo?.category}
                      </span>
                      <span style={{ color: '#e1e2e4' }}>・</span>
                      <span>
                        {basicInfo &&
                          convertPriceForUnit(
                            unit,
                            basicInfo.landArea,
                            basicInfo.landAreaPyoeng,
                            basicInfo.buildingArea,
                            basicInfo.buildingAreaPyoeng,
                          )}
                        {unit === 'm' ? 'm²' : '평'}
                        (전용)
                      </span>
                    </s.InfoText>
                  </s.Info> */}
                  {/* <s.ChangeUnitButton
                    onClick={() =>
                      setUnit((prev) => (prev === 'm' ? 'p' : 'm'))
                    }
                  >
                    <img src="/assets/images/icon/refresh.svg" alt="switch" />
                    {unit === 'm' ? '평' : 'm²'}
                  </s.ChangeUnitButton> */}
                </s.InfoList>
                <s.Info>
                  <img src="/assets/images/icon/auction.svg" alt="" />
                  <s.InfoText>
                    <span>{caseInfo?.branchName}</span>
                    <span style={{ color: '#e1e2e4' }}>・</span>
                    <span>
                      {caseInfo?.caseno}
                      {caseInfo?.type === 'p'
                        ? '-' + caseInfo?.itemno
                        : caseInfo?.itemno.replace(/[^0-9]/g, '')
                          ? ' (' + caseInfo?.itemno.replace(/[^0-9]/g, '') + ')'
                          : ' (1)'}
                    </span>
                  </s.InfoText>
                </s.Info>
                <s.Info>
                  <img src="/assets/images/icon/calendar-outline.svg" alt="" />
                  <s.InfoText>
                    <span style={{ whiteSpace: 'nowrap' }}>
                      {caseInfo.type === 'a' ? '매각기일' : '입찰기간'}
                    </span>
                    <span style={{ color: '#e1e2e4' }}>・</span>
                    <s.InfoDateBox>
                      {caseInfo.type === 'a'
                        ? formatDate(caseInfo.saleDate)
                        : caseInfo.saleDate}
                      {caseInfo.type === 'a' &&
                        caseInfo.date.remaining_days !== null && (
                          <s.DDayBadge>
                            입찰 D
                            {caseInfo?.date?.remaining_days > 0
                              ? `-${caseInfo?.date?.remaining_days}`
                              : `+${Math.abs(caseInfo?.date?.remaining_days)}`}
                            일
                          </s.DDayBadge>
                        )}
                    </s.InfoDateBox>
                  </s.InfoText>
                </s.Info>
              </s.InfoArea>
              <Tags data={caseInfo} />
            </s.DetailArea>
          </s.SummaryDetail>

          <s.Bottom>
            <s.PriceArea>
              <s.InfoList>
                <s.PriceAreaInfoText>감정가</s.PriceAreaInfoText>
                <s.PriceText>
                  {formatToEokMan(basicInfo?.appraisalPrice)}
                </s.PriceText>
              </s.InfoList>
              <s.InfoList>
                <s.PriceAreaInfoText>AI 시세</s.PriceAreaInfoText>
                <s.PriceText>{formatToEokMan(summary.row2_1)}</s.PriceText>
              </s.InfoList>
              <s.InfoList>
                <s.PriceAreaInfoText>예상 낙찰가</s.PriceAreaInfoText>
                <s.PriceText>{formatToEokMan(summary.row4_1)}</s.PriceText>
              </s.InfoList>
              <s.InfoList>
                <s.MinimumPriceInfoText>
                  채권청구액
                  <s.MinimumPercentBadge>
                    - {ReportFormatNumber(summary.row3_2, true)}
                  </s.MinimumPercentBadge>
                </s.MinimumPriceInfoText>
                <s.MinimumPriceText>
                  {formatToEokMan(summary.row3_1)}
                </s.MinimumPriceText>
              </s.InfoList>
            </s.PriceArea>

            <s.ViewCountBox>
              <s.ViewCount>
                <span>・오늘조회</span>{' '}
                {viewInfo?.today_view_count ? viewInfo.today_view_count : '-'}
              </s.ViewCount>
              <s.ViewCount>
                <span>・누적조회</span>{' '}
                {viewInfo?.view_count ? viewInfo.view_count : '-'}
              </s.ViewCount>
              <s.ViewCount>
                <span>・5분이상</span>{' '}
                {regionAccess ? (
                  <>
                    {viewInfo?.valid_view_count
                      ? viewInfo.valid_view_count
                      : '-'}
                  </>
                ) : (
                  <img
                    src="/assets/images/icon/lock.svg"
                    alt=""
                    style={{ width: '16px' }}
                  />
                )}
              </s.ViewCount>
            </s.ViewCountBox>
          </s.Bottom>
        </s.SummaryBox>

        {showLikeModal && (
          <AddInterestItemModal
            setShowLikeModal={setShowLikeModal}
            selectedIdx={caseInfo.iidx}
            mode={mode}
            selectedItem={selectedItem}
            setActiveItem={setActiveItem}
            checkIsLikeItem={checkIsLikeItem}
          />
        )}
      </s.Container>
    );
  },
);

export default NPLInvestmentSummary;
